import axios from 'axios';

const baseURL = 'https://certi.masaischool.com'; 

// const baseURL = 'http://localhost:8080'

const authDetails = JSON.parse(localStorage.getItem("authDetails"));
let token = authDetails?.token;

const apiInstance = axios.create({
  baseURL,
  headers: {
          Authorization: `Bearer ${token}`,
  }
});

export default apiInstance;
